import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

// Login Page
import LoginPage from './LoginPage';

// Web Form Page
import WebFormDetailPage from './WebFormDetailPage';

// Rating Page
import RatingPage from './RatingPage';

export default history =>
	combineReducers({
		form: formReducer,
		router: connectRouter(history),
		loginPageReducer: LoginPage,
		webFormDetailPageReducer: WebFormDetailPage,
		ratingPageReducer: RatingPage
	});
